import React, { useEffect, useState } from "react";
import { Avatar, CardHeader } from "@mui/material";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const TicketInfo = ({ contact, ticket, onClick, presence }) => {
	const [lastSeen, setLastSeen] = useState(null);

	useEffect(() => {
		if (!ticket?.id || presence?.isOnline) {
			setLastSeen(null);
			return;
		}
		let cancelled = false;
		api.get(`/messages/${ticket.id}/last-seen`).then(({ data }) => {
			if (!cancelled && data.lastSeen) {
				setLastSeen(data.lastSeen);
			}
		}).catch(() => {});
		return () => { cancelled = true; };
	}, [ticket?.id, presence?.isOnline]);

	const userLabel = ticket.user
		? ticket.status === "closed"
			? `· Resolvido por: ${ticket.user.name}`
			: ticket.status === "open"
			? `· ${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
			: null
		: null;

	const presenceLabel = presence?.isTyping
		? "✏️ Digitando..."
		: presence?.isOnline
		? "🟢 Online"
		: lastSeen
		? `⏱ Visto ${formatLastSeen(lastSeen)}`
		: null;

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" sx={{ width: 52, height: 52 }} />}
			title={`${contact.name} #${ticket.id}`}
			subheader={
				<span>
					{contact.number}
					{presenceLabel && (
						<span style={{ marginLeft: 8, color: presence?.isTyping ? "#888" : presence?.isOnline ? "#27AE60" : "#999", fontSize: "0.85em" }}>
							{presenceLabel}
						</span>
					)}
					{userLabel && <span style={{ marginLeft: 4 }}>{userLabel}</span>}
				</span>
			}
		/>
	);
};

function formatLastSeen(ts) {
	const date = new Date(typeof ts === "number" ? ts * 1000 : ts);
	const now = new Date();
	const diffMs = now - date;
	const diffMin = Math.floor(diffMs / 60000);
	if (diffMin < 1) return "agora há pouco";
	if (diffMin < 60) return `há ${diffMin} min`;
	const diffH = Math.floor(diffMin / 60);
	if (diffH < 24) return `às ${format(date, "HH:mm")}`;
	return `em ${format(date, "dd/MM", { locale: ptBR })}`;
}

export default TicketInfo;
